import { RootState } from 'editor/src/store/index';

const getTextEditMode = (state: RootState) => state.editor.textEditMode;

export default getTextEditMode;
